import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from "../../context/ThemeProvider";
import OnboardingLayout from "./OnboardingLayout";
import QuestionReview from "../questionReview";

const OnboardingQuestionReview = () => {
  const { state } = useLocation();
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  
  const title = state?.title || "Question Review";
  const testData = state?.testData;
  const questions = state?.questions;
  
  console.log("OnboardingQuestionReview state:", state);
  console.log("OnboardingQuestionReview questions:", questions);

  return (
    <OnboardingLayout>
      <div className="min-h-screen transition-colors duration-300" 
           style={{ background: theme?.background?.main }}>
        <div className="mx-4 sm:mx-4 md:mx-8 lg:mx-8 mb-4 sm:mb-4 md:mb-8 lg:mb-8 mt-20">
          {/* Custom Header */}
          <div className="mb-8">
            <div className="flex items-start gap-4">
              <button
                onClick={() => navigate('/onboarding-test-review', { 
                  state: { 
                    historyData: testData, 
                    selected_exam: JSON.parse(localStorage.getItem('onboarding_test_selected_exam'))
                  } 
                })}
                className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 mt-1"
                style={{ 
                  background: theme?.dashboard?.card?.background || '#f8fafc',
                  border: `1px solid ${theme?.dashboard?.card?.border || '#e2e8f0'}`,
                  color: theme?.text?.secondary
                }}
              >
                <FontAwesomeIcon icon={faChevronLeft} className="w-5 h-5" />
              </button>
              <div>
                <h1 className="text-3xl font-bold mb-2" style={{ color: theme?.text?.primary }}>
                  {title}
                </h1>
                <p className="text-lg" style={{ color: theme?.text?.secondary }}>
                  Review your assessment questions and understand your performance
                </p>
              </div>
            </div>
          </div>
          
          {/* QuestionReview Component */}
          <QuestionReview isOnboarding={true} />
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingQuestionReview;